import React from 'react';
import { useTranslation } from 'react-i18next';

const Community = () => {
  const { t } = useTranslation();

  return (
    <section id="how-to-play" className="community-section">
      <div className="community-content">
        <div className="community-text">
          <p className="community-label">{t('community.label')}</p>
          <h2 className="community-headline">
            {t('community.headline')}
          </h2>
          <p className="community-body">
            {t('community.body')}
          </p>
          <a href="https://www.youtube.com/watch?v=pDDwZgepQeE&ab_channel=PlayPickleball.com" className="community-button">{t('community.button')}</a>
        </div>
      </div>
    </section>
  );
};

export default Community;